// client/src/view/ForgetPassword/ForgetPassword.js
import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import toast from 'react-hot-toast';

function ForgetPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/password/forgot`, { email });
            toast.success(response.data.message || 'لینک بازنشانی به ایمیل شما ارسال شد.');
            setSubmitted(true);
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || 'خطایی در ارسال درخواست رخ داد.');
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <>
                <Navbar />
                <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                    <div className="text-center">
                        <h3>ایمیل بازنشانی ارسال شد!</h3>
                        <p>لطفاً صندوق ورودی ایمیل خود را بررسی کنید.</p>
                        <Link to="/login" className="btn btn-primary">بازگشت به صفحه ورود</Link>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <div className="col-md-6">
                    <div className="card shadow p-4">
                        <h2 className="text-center mb-4">فراموشی رمز عبور</h2>
                        <p className="text-muted text-center mb-4">
                            ایمیل خود را وارد کنید. لینک بازنشانی رمز عبور برای شما ارسال خواهد شد.
                        </p>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">آدرس ایمیل</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-warning w-100" disabled={loading}>
                                {loading ? 'در حال ارسال...' : 'ارسال لینک بازنشانی'}
                            </button>
                        </form>
                        <div className="text-center mt-3">
                            <Link to="/login">بازگشت به صفحه ورود</Link>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default ForgetPassword;